import {Component, Inject, OnDestroy, OnInit, Renderer2} from '@angular/core';
import {ChatService} from '@services/chat.service';
import {I18nService} from '@services/i18n.service';
import {DOCUMENT} from '@angular/common';

declare global {
  interface Window {
    watsonAssistantChatOptions: any;
    WebChatInstance: any;
  }
}

@Component({
  selector: 'si-chat',
  templateUrl: './chat.component.html',
  styleUrls: ['./chat.component.scss']
})
export class ChatComponent implements OnInit, OnDestroy {
  private watsonScriptId = 'watson-script';

  constructor(
    private chatService: ChatService,
    private i18nService: I18nService,
    private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document
  ) {
  }

  ngOnInit(): void {
    this.initializeChat();
  }

  initializeChat(): void {
    window.watsonAssistantChatOptions = {
      integrationID: 'd80ff516-a201-41ee-a56d-93879f63a59e',
      region: 'eu-gb',
      serviceInstanceID: 'b73c90db-14db-49a3-adf9-207d3349bab9',
      showLauncher: false,
      openChatByDefault: false,
      onLoad: async (instance: any) => {
        // Web chat makes an asynchronous request to get other language data so you need to use async/await.
        await instance.updateLocale(this.i18nService.getLanguageShort());
        window.WebChatInstance = instance;
        instance.render();
      }
    };

    let watsonScriptElement: HTMLScriptElement = this.document.getElementById(this.watsonScriptId) as HTMLScriptElement;
    if (!watsonScriptElement) {
      watsonScriptElement = this.renderer.createElement('script');
      watsonScriptElement.setAttribute('id', this.watsonScriptId);
      watsonScriptElement.src = 'https://web-chat.global.assistant.watson.appdomain.cloud/versions/latest/WatsonAssistantChatEntry.js';
      this.renderer.appendChild(this.document.body, watsonScriptElement);
    }
  }

  onClickOpenChat(): void {
    this.openChat();
  }

  openChat(): void {
    this.chatService.openChatWindow();
  }

  ngOnDestroy(): void {
    this.chatService.closeChatWindow();
    this.chatService.destroyChatSession();
  }
}
